export const FIRST_TWO_WEEKS_THRESHOLD = 14;

export type WelcomeFromRovoChatEligibility = {
	isEligible: boolean;
	loading: boolean;
};

export const getWelcomeFromRovoChatEligibility = ({
	currentUserPersonalSpaceKey,
	isFoundingAdmin,
	isFoundingAdminLoading,
	isCurrentSpacePersonal,
	isNewUser,
	isNewUserLoading,
	spaceKey,
	shouldSkipEligibilityCheck,
}: {
	currentUserPersonalSpaceKey?: string | null;
	isFoundingAdmin: boolean | null | undefined;
	isFoundingAdminLoading: boolean;
	isCurrentSpacePersonal?: boolean;
	isNewUser: boolean | null | undefined;
	isNewUserLoading?: boolean;
	spaceKey?: string;
	shouldSkipEligibilityCheck: boolean;
}): WelcomeFromRovoChatEligibility => {
	if (shouldSkipEligibilityCheck || isFoundingAdmin === true) {
		return { isEligible: false, loading: false };
	}

	if (isFoundingAdminLoading) {
		return { isEligible: false, loading: true };
	}

	if (isCurrentSpacePersonal) {
		if (currentUserPersonalSpaceKey === undefined) {
			return { isEligible: false, loading: true };
		}

		if (
			currentUserPersonalSpaceKey === null ||
			!spaceKey ||
			spaceKey === currentUserPersonalSpaceKey
		) {
			return { isEligible: false, loading: false };
		}
	}

	// Treat undefined loading as unresolved until useIsNewUser returns a definitive state.
	if (isNewUserLoading !== false) {
		return isNewUser === false
			? { isEligible: false, loading: false }
			: { isEligible: false, loading: true };
	}

	if (isNewUser !== true) {
		return { isEligible: false, loading: false };
	}

	return { isEligible: true, loading: false };
};
